var React = require('react');

function PillMedium (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.5727 53.082C13.2957 53.082 1.71436 41.4557 1.71436 27.1045C1.71436 12.7533 13.2957 1.12695 27.5727 1.12695H96.6678C110.945 1.12695 122.526 12.7533 122.526 27.1045C122.526 41.4557 110.945 53.082 96.6678 53.082H27.5727Z","strokeWidth":"2"}));
}

PillMedium.defaultProps = {"width":"124","height":"55","viewBox":"0 0 124 55"};

module.exports = PillMedium;

PillMedium.default = PillMedium;
